import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierRateList extends Layout {
    layoutheaderCarrierRateList: LayoutHeader;
    sourceCarrierRate: DataSource;
    tableCarrierRate: Table;
}
